import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from '../contexts/TranslationContext';
import { getMobileScreenTitle, shouldShowMobileTabBar } from './mobileNavConfig';

const GADKOT_LOGO = `${process.env.PUBLIC_URL || ''}/images/gadkot_logo.png`;

export default function MobileTopBar({ title }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const showBack = !shouldShowMobileTabBar(pathname);
  const screenTitle = title || getMobileScreenTitle(pathname, t);

  return (
    <header className="mobile-top-bar">
      <div className="mobile-top-bar__inner">
        {showBack ? (
          <button type="button" className="mobile-top-bar__back" onClick={() => navigate(-1)} aria-label={t('mobile.back')}>
            <ArrowLeft className="h-5 w-5" />
          </button>
        ) : (
          <img src={GADKOT_LOGO} alt="" className="mobile-top-bar__logo" width={36} height={36} />
        )}
        <h1 className="mobile-top-bar__title font-marathi font-marathi-display">{screenTitle}</h1>
        <div className="mobile-top-bar__spacer" aria-hidden />
      </div>
    </header>
  );
}
